<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-12">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a [routerLink]="['/home']">Home</a>
              </li>
            <li class="breadcrumb-item">
                <a>Customers</a>
            </li>
        </ol>
    </div>
</div>

<div class="wrapper wrapper-content">
    <div class="row">
        <div class="col-lg-8 col-md-12 mt-2">
            <div class="card bg-emphasis bg-opacity-25">
                <div class="card-header">
                    <div class="d-flex fw-bold small">
                        <span class="flex-grow-1">
                            <h5>Customers</h5>                        
                        </span>
                        <span class="d-flex align-items-center me-3">
                            <input type="checkbox" class="form-check-input me-2" id="showArchivedCheck" [(ngModel)]="includeArchived" (change)="onCheckboxChange($event)">
                            <label class="form-check-label" for="showArchivedCheck">Show Archived</label>
                        </span>   
                        <span>
                            <button class="btn btn-primary btn-sm" (click)="openCustomerModal()">Add Customer</button>
                        </span>
                    </div>
                </div>
                <div class="card-body">
                    <ng-table [tableKeys]="customerTableKeys" [tableRows]="customersFormatted" [isUpdateEnabled]="true" (selectRowEvent)="selectCustomer($event)" (updateRowEvent)="beginUpdateCustomer($event)" (deleteRowEvent)="deleteCustomer($event)"></ng-table>
                </div>
            </div>
        </div>

        <div class="col-lg-4 col-md-12 mt-2">
            <div class="card bg-red bg-opacity-5">
                <div class="card-header">
                    <h5>All Customer Alerts</h5>
                </div>
                <div class="card-body">
                    <app-alerts [alerts]="customersAlerts"></app-alerts>
                </div>
            </div>
        </div>

    </div>
    <div class="row mt-2" *ngIf="configService.featureAllowed('products')">
    
        <div class="col-lg-6">
            <div class="mt-2"></div>
            <div class="card bg-emphasis bg-opacity-25">
                <div class="card-header">
                    <h3>License Summary</h3>
                </div>
                <div class="card-body">
                    <!-- License Summary Table - show all customers that are 'active' and have a license assigned -->
                    <div class="table-responsive">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Customer Name</th>
                                    <th>License Name</th>
                                    <th>Price</th>
                                    <th>Valid To</th>
                                    <th>Valid To</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngIf="clicenses == null || clicenses.length === 0; else licenseRows">
                                    <td colspan="7" class="text-center text-muted">No active customers with licenses found</td>
                                </tr>
                                <ng-template #licenseRows>
                                    <tr *ngFor="let item of clicenses">
                                        <td>{{ item.customerName }}</td>
                                        <td>
                                            <div *ngFor="let license of item.licenses">
                                                {{ license.licenseType.licenseName }}
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngFor="let license of item.licenses">
                                                {{ license.price | currency }}
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngFor="let license of item.licenses">
                                                {{ license.expiredDate | date:'short' }}
                                            </div>
                                        </td>
                                        <td>
                                            <div *ngFor="let license of item.licenses">
                                                {{ license.expiredDate | relativeDate }}
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                            <tfoot *ngIf="clicenses != null && clicenses.length > 0">
                                <!-- totalise the Price column-->
                                <tr>
                                    <td colspan="2" class="text-end fw-bold">Total Price:</td>
                                    <td class="fw-bold">{{ getTotalLicensePrice() | currency }}</td>
                                    <td colspan="2"></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- add a table showing the totals due per month based on the clicense collection -->
        <div class="col-lg-6">
            <div class="mt-2"></div>
            <div class="card bg-emphasis bg-opacity-25">
                <div class="card-header">
                    <h3>Monthly Revenue Forecast ({{ getCurrentYear() }})</h3>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Month</th>
                                    <th class="text-end">Amount Due</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let monthData of getMonthlyAmountsDue()" [class.table-success]="monthData.amount > 0">
                                    <td>{{ monthData.month }}</td>
                                    <td class="text-end fw-bold">{{ monthData.amount | currency }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="table-primary">
                                    <td class="fw-bold">Total Annual Revenue</td>
                                    <td class="text-end fw-bold">{{ getTotalLicensePrice() | currency }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" bsModal #customerModal="bs-modal" tabindex="-1" role="dialog" (onHidden)="closeCustomerModal()">
    <div class="modal-dialog bg-emphasis bg-opacity-30 modal-xl">
        <!-- Form -->
        <form class="modal-form" class="was-validated-2" (ngSubmit)="saveCustomer()" [formGroup]="customerGroupModel">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title pull-left">{{ isUpdatingCustomer ? "Update" : "Create" }} Customer</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Customer Name</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" formControlName="customerName" [class.is-invalid]="customerGroupModel.controls['customerName'].invalid">
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Active</label>
                                <div class="col-sm-8">
                                    <div class="form-check form-switch">
                                        <input type="checkbox" class="form-check-input" formControlName="active">
                                        <label class="form-check-label">Active</label>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Telephone</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" formControlName="telephone" [class.is-invalid]="customerGroupModel.controls['telephone'].invalid">
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Address</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" formControlName="address" [class.is-invalid]="customerGroupModel.controls['address'].invalid">
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Alert Message</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" formControlName="customerMessage" [class.is-invalid]="customerGroupModel.controls['customerMessage'].invalid">
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Domain Name</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" formControlName="domainName" [class.is-invalid]="customerGroupModel.controls['domainName'].invalid">
                                </div>
                            </div>           

                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Customer Code</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" maxlength="12" formControlName="customerCode" [class.is-invalid]="customerGroupModel.controls['customerCode'].invalid">
                                </div>
                            </div>

                            <hr>
                            <span class="badge bg-primary mt-2">Time Series</span>   
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Time Series Connection Type</label>
                                <div class="col-sm-8">
                                    <select class="form-control form-select" formControlName="timeSeriesConnectorId">
                                        <option *ngFor="let conn of connectors" [value]="conn.connectorId">{{conn.name}}</option>
                                    </select>
                                </div>
                            </div>                                      
                            
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Time Series Connection String</label>
                                <div class="col-sm-8">
                                    <textarea rows="1" class="form-control" autocomplete="off" type="text" formControlName="timeSeriesConnectionString" [class.is-invalid]="customerGroupModel.controls['timeSeriesConnectionString'].invalid"></textarea>
                                </div>
                                <label class="col-sm-4 col-form-label text-inverse text-opacity-50" *ngIf="customerGroupModel.controls['timeSeriesConnectorId'].value == 3"><small>Template</small></label>
                                <div class="col-sm-8" *ngIf="customerGroupModel.controls['timeSeriesConnectorId'].value == 3">
                                    <input class="form-control form-control-sm  text-inverse text-opacity-50" autocomplete="off" type="text" readonly value="BaseUrl=&lt;url&gt;;ServerName=&lt;name&gt;;DatabaseName=&lt;name&gt;;Username=&lt;username&gt;;Password=&lt;password&gt;;SubscriptionKey=&lt;subscriptionkey&gt;;CacheTimeout=&lt;timeoutseconds&gt;">
                                </div>
                            </div>                                        
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Live Data</label>
                                <div class="col-sm-8">
                                    <input type="checkbox" class="form-check-input" formControlName="enableLiveData" [class.is-invalid]="customerGroupModel.controls['enableLiveData'].invalid">
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Allow Alarms</label>
                                <div class="col-sm-8">
                                    <input type="checkbox" class="form-check-input" formControlName="allowsAlarms" [class.is-invalid]="customerGroupModel.controls['allowsAlarms'].invalid">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Map Centrepoint Latitude</label>
                                <div class="col-sm-8">
                                    <input type="number" class="form-control" formControlName="centreMapLatitude"
                                        [class.is-invalid]="customerGroupModel.controls['centreMapLatitude'].invalid">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Map Centrepoint Longitude</label>
                                <div class="col-sm-8">
                                    <input type="number" class="form-control" formControlName="centreMapLongitude"
                                        [class.is-invalid]="customerGroupModel.controls['centreMapLongitude'].invalid">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Map Default Zoom</label>
                                <div class="col-sm-8">
                                    <input type="number" class="form-control" formControlName="zoomLevel"
                                        [class.is-invalid]="customerGroupModel.controls['zoomLevel'].invalid">
                                </div>
                            </div>
                        </div>


                        <div class="col-6">
                            <span class="badge bg-primary">Media</span>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Media Connection Type</label>
                                <div class="col-sm-8">
                                    <select class="form-control form-select" formControlName="mediaConnectorId">
                                        <option *ngFor="let conn of mconnectors" [value]="conn.connectorId">{{conn.name}}</option>
                                    </select>
                                </div>
                            </div>     
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Media Connection String</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" formControlName="mediaConnectionString" [class.is-invalid]="customerGroupModel.controls['mediaConnectionString'].invalid">
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Media Container Name</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" formControlName="mediaContainerName" [class.is-invalid]="customerGroupModel.controls['mediaContainerName'].invalid">
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Content Delivery Network (CDN) Domain</label>
                                <div class="col-sm-8">
                                    <input class="form-control" autocomplete="off" type="text" formControlName="contentDeliveryNetwork" [class.is-invalid]="customerGroupModel.controls['contentDeliveryNetwork'].invalid">
                                </div>
                            </div>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Media Requires SASS Token</label>
                                <div class="col-sm-8">
                                    <input type="checkbox" class="form-check-input" formControlName="mediaRequireSassToken" [class.is-invalid]="customerGroupModel.controls['mediaRequireSassToken'].invalid">
                                </div>
                            </div>
                            <hr>
                            <span class="badge bg-primary mt-2">Control</span>
                            <div class="mt-2"></div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label">Enable Control</label>
                                <div class="col-sm-8">
                                    <input type="checkbox" class="form-check-input" formControlName="enableControl" [class.is-invalid]="customerGroupModel.controls['enableControl'].invalid">
                                </div>
                            </div>   
                            <div *ngIf="customerGroupModel.controls['enableControl'].value">
                                <div class="mt-2"></div>
                                <div class="form-group row">
                                    <label class="col-sm-4 col-form-label">Control type</label>
                                    <div class="col-sm-8">
                                        <select class="form-control form-select" formControlName="controlType">
                                            <option value="0">Event Hubs</option>
                                            <option value="1">Storage Queues</option>
                                            <option value="2">Web Hooks</option>
                                        </select>
                                    </div>
                                </div>   
                                <div class="mt-2" *ngIf="customerGroupModel.controls['controlType'].value == 0"></div>
                                <div class="form-group row" *ngIf="customerGroupModel.controls['controlType'].value == 0">
                                    <label class="col-sm-4 col-form-label">EventHub Connection String</label>
                                    <div class="col-sm-8">
                                        <input class="form-control" autocomplete="off" type="text" formControlName="eventHubConnectionString" [class.is-invalid]="customerGroupModel.controls['eventHubConnectionString'].invalid">
                                    </div>
                                </div>
                                <div class="mt-2" *ngIf="customerGroupModel.controls['controlType'].value == 0"></div>
                                <div class="form-group row" *ngIf="customerGroupModel.controls['controlType'].value == 0">
                                    <label class="col-sm-4 col-form-label">EventHub Name</label>    
                                    <div class="col-sm-8">
                                        <input class="form-control" autocomplete="off" type="text" formControlName="eventHubName" [class.is-invalid]="customerGroupModel.controls['eventHubName'].invalid">
                                    </div>
                                </div>
                                <div class="mt-2" *ngIf="customerGroupModel.controls['controlType'].value == 2"></div>
                                <div class="form-group row" *ngIf="customerGroupModel.controls['controlType'].value == 2">
                                    <label class="col-sm-4 col-form-label">Web Hook - DataBus Address</label>
                                    <div class="col-sm-8">
                                        <input class="form-control" autocomplete="off" type="text" formControlName="dataBusAddress" [class.is-invalid]="customerGroupModel.controls['dataBusAddress'].invalid">
                                    </div>
                                </div>
                                <div class="mt-2" *ngIf="customerGroupModel.controls['controlType'].value == 2"></div>
                                <div class="form-group row"  *ngIf="customerGroupModel.controls['controlType'].value == 2">
                                    <label class="col-sm-4 col-form-label">Web Hook - DataSource URI</label>
                                    <div class="col-sm-8">
                                        <input class="form-control" autocomplete="off" type="text" formControlName="webHookDataSourceUri" [class.is-invalid]="customerGroupModel.controls['webHookDataSourceUri'].invalid">
                                    </div>
                                </div>
                                <div class="mt-2" *ngIf="customerGroupModel.controls['controlType'].value == 2"></div>
                                <div class="form-group row" *ngIf="customerGroupModel.controls['controlType'].value == 2">
                                    <label class="col-sm-4 col-form-label">Web Hook - API KEY</label>
                                    <div class="col-sm-8">
                                        <input class="form-control" autocomplete="off" type="text" formControlName="webHookApiKey" [class.is-invalid]="customerGroupModel.controls['webHookApiKey'].invalid">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                                    
                    
                </div>
                <div class="modal-footer">
                    <div class="flex-grow-1">
                        <button *ngIf="isUpdatingCustomer && !customerToUpdate?.archived" class="btn btn-warning" type="button" (click)="archiveCustomer()">Archive Customer</button>
                        <button *ngIf="isUpdatingCustomer && customerToUpdate?.archived" class="btn btn-success" type="button" (click)="unarchiveCustomer()">Unarchive Customer</button>
                    </div>
                    <button class="btn btn-default" type="button" (click)="closeCustomerModal()">Cancel</button>
                    <button class="btn btn-primary" type="submit" [disabled]="!customerGroupModel.valid">{{ isUpdatingCustomer ? "Update" : "Create" }} Customer</button>
                </div>
            </div>
        </form>
    </div>

</div>